export const normalizeId = (value) => {
  if (value == null || value === '') return '';
  return String(value);
};

const normalizeAssignmentEntry = (value) => {
  if (value == null) return null;

  if (typeof value === 'object' && !Array.isArray(value)) {
    const interviewerId = value.interviewer_id ?? value.interviewerId;
    if (interviewerId == null) return null;
    return {
      interviewer_id: Number(interviewerId),
      interviewer_email: value.interviewer_email ?? value.interviewerEmail ?? null
    };
  }

  if (typeof value === 'number' || typeof value === 'string') {
    return {
      interviewer_id: Number(value),
      interviewer_email: null
    };
  }

  return null;
};

export const getAssignmentEntries = (assignments, appId) => {
  if (appId == null || !assignments) return [];

  const entry = assignments[appId] ?? assignments[String(appId)];
  if (entry == null) return [];

  if (Array.isArray(entry)) {
    return entry
      .map((item) => normalizeAssignmentEntry(item))
      .filter(Boolean);
  }

  const single = normalizeAssignmentEntry(entry);
  return single ? [single] : [];
};

export const getAssignmentEntry = (assignments, appId) => {
  const entries = getAssignmentEntries(assignments, appId);
  return entries[0] ?? null;
};

export const getAssignmentInterviewerId = (assignments, appId) => (
  getAssignmentEntry(assignments, appId)?.interviewer_id ?? null
);

export const getAssignmentInterviewerEmail = (assignments, appId) => (
  getAssignmentEntry(assignments, appId)?.interviewer_email ?? null
);

export const isApplicationAssignedToUser = (assignments, appId, currentUser) => {
  const entries = getAssignmentEntries(assignments, appId);
  if (!entries.length) return false;

  const userId = normalizeId(currentUser?.id);
  const userEmail = (currentUser?.email || '').trim().toLowerCase();

  return entries.some((entry) => {
    if (userId && normalizeId(entry.interviewer_id) === userId) return true;
    const entryEmail = (entry.interviewer_email || '').trim().toLowerCase();
    return Boolean(userEmail && entryEmail && entryEmail === userEmail);
  });
};

export const isApplicationAssignedToInterviewer = (assignments, appId, interviewer) => (
  isApplicationAssignedToUser(assignments, appId, interviewer)
);

export const buildAssignmentEntry = (interviewerId, interviewerEmail = '') => ({
  interviewer_id: Number(interviewerId),
  interviewer_email: interviewerEmail || null
});

export const normalizeAssignmentsMap = (data = {}) => {
  if (!data || typeof data !== 'object') return {};

  return Object.entries(data).reduce((acc, [appId, value]) => {
    if (Array.isArray(value)) {
      const entries = value
        .map((item) => normalizeAssignmentEntry(item))
        .filter(Boolean);
      if (entries.length) acc[String(appId)] = entries;
      return acc;
    }

    const single = normalizeAssignmentEntry(value);
    if (single) acc[String(appId)] = [single];
    return acc;
  }, {});
};

export const parseAssignmentsResponse = (result) => {
  if (!result || typeof result !== 'object') return null;

  if (result.status === 'success' && result.data && typeof result.data === 'object') {
    return normalizeAssignmentsMap(result.data);
  }

  if (!('status' in result) && !('message' in result)) {
    return normalizeAssignmentsMap(result);
  }

  return null;
};

export const isDepartmentInterviewerUser = (user) => {
  const role = (user?.role || '').toUpperCase();
  const position = (user?.position || '').toUpperCase();

  if (role === 'HEAD ADMIN' || position === 'HEAD ADMIN') return false;

  return (
    position.includes('HR') ||
    role === 'HR' ||
    position.includes('OPER') ||
    role === 'OPERATIONS' ||
    position.includes('TEAM LEADER') ||
    position.includes('TEAM LEAD') ||
    role === 'TL' ||
    role === 'TEAM LEADER' ||
    position.includes('CLIENT') ||
    role === 'CLIENT'
  );
};
